import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useCastleSection = (onSectionChange) => {
  const location = useLocation();

  useEffect(() => {
    // Check if we're on any castle-related page
    if (
      location.pathname === '/' || // Home page
      location.pathname === '/your-visit/opening-times' ||
      location.pathname === '/your-visit/directions' ||
      location.pathname === '/your-visit/accessibility' ||
      location.pathname === '/your-visit/tours' ||
      location.pathname === '/your-visit/groups' ||
      location.pathname === '/your-visit/schools' ||
      location.pathname === '/castle-dining' ||
      location.pathname === '/castle-dining/aviary-tearoom' ||
      location.pathname === '/castle-dining/afternoon-tea' ||
      location.pathname === '/castle-dining/afternoon-tea-booking' ||
      location.pathname === '/about' ||
      location.pathname === '/about/castle-and-state-rooms' ||
      location.pathname === '/about/history' ||
      location.pathname === '/about/gardens' ||
      location.pathname === '/about/belvoir-wines' ||
      location.pathname === '/about/adventure-playground' ||
      location.pathname === '/about/gift-vouchers' ||
      location.pathname === '/about/parking' ||
      location.pathname === '/about/dog-friendly' ||
      // Events-related paths
      location.pathname === '/whats-on' ||
      location.pathname === '/whats-on/events' ||
      location.pathname === '/whats-on/exhibitions' ||
      location.pathname === '/whats-on/featured-tours' ||
      location.pathname === '/whats-on/seasonal-activities' ||
      location.pathname === '/whats-on/exhibition-booking' ||
      location.pathname.startsWith('/event/') // For individual event pages
    ) {
      // Force the Castle section to be active
      onSectionChange('castle');
    }
  }, [location.pathname, onSectionChange]);
};

export default useCastleSection; 